import { render, staticRenderFns } from "./JobDetial.vue?vue&type=template&id=45ab9096&scoped=true"
import script from "./JobDetial.vue?vue&type=script&lang=js"
export * from "./JobDetial.vue?vue&type=script&lang=js"
import style0 from "./JobDetial.vue?vue&type=style&index=0&id=45ab9096&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45ab9096",
  null
  
)

export default component.exports